import { Message } from '../types';

// Helper to generate a random conversation ID
export const randomId = (): string => {
  return Math.random().toString(36).substring(2, 8).toUpperCase();
};

// Default welcome message when no conversation is selected
export const defaultWelcome: Message[] = [
  {
    id: '1',
    textKey: 'assistantWelcome',
    sender: 'AI Assistant',
    timestamp: new Date(),
    isAssistant: true,
    messageType: 'assistant'
  }
];

// Scroll to bottom utility function
export const scrollToBottom = (messagesEndRef: React.RefObject<HTMLDivElement | null>): void => {
  requestAnimationFrame(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  });
};

// Format time utility function
export const formatTime = (date: Date): string => {
  return date.toLocaleTimeString('en-GB', { 
    hour: '2-digit', 
    minute: '2-digit',
    hour12: false 
  });
}; 